module.exports = __webpack_public_path__ + "static/other/organize_desk_game_desk_6.031fb993.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/organizeDeskGame/organize_desk_game_desk_6.json
// module id = 2354
// module chunks = 0